<template>
  <v-dialog :model-value="modelValue" max-width="520" persistent @update:model-value="emit('update:modelValue', $event)">
    <div class="bb-match">
      <div class="bb-match__head">
        <div>
          <h3>{{ title }}</h3>
        </div>
        <div class="bb-match__head-tools">
          <button type="button" class="bb-match__q" :class="{ on: guideOpen }" title="설명" @click="guideOpen = !guideOpen">
            <v-icon size="18">mdi-help-circle-outline</v-icon>
          </button>
          <button type="button" class="bb-match__x" title="닫기" @click="close">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>
      </div>

      <div class="bb-match__body">
        <div v-if="guideOpen" class="bb-match__guide">
          <section v-for="(block, index) in guideBlocks" :key="index">
            <strong>{{ block.title }}</strong>
            <div v-if="block.sample" class="bb-match__sample">
              <div class="bb-match__sample-side">
                <span v-if="block.sample.fromLabel" class="bb-match__sample-name">{{ block.sample.fromLabel }}</span>
                <span class="bb-match__sample-val">{{ block.sample.from }}</span>
              </div>
              <em>→</em>
              <div class="bb-match__sample-side">
                <span v-if="block.sample.toLabel" class="bb-match__sample-name">{{ block.sample.toLabel }}</span>
                <span class="bb-match__sample-val">{{ block.sample.to }}</span>
              </div>
            </div>
            <p v-for="(line, lineIndex) in block.lines" :key="lineIndex"><span>*</span>{{ line }}</p>
          </section>
        </div>
        <div v-if="kind !== 'rel'" class="bb-match__tabs" role="tablist">
          <button
            type="button"
            class="is-in"
            :class="{ on: gubun === 'IN' }"
            :disabled="kind === 'rel'"
            @click="gubun = 'IN'"
          >수입</button>
          <button type="button" class="is-out" :class="{ on: gubun === 'OUT' }" @click="gubun = 'OUT'">지출</button>
        </div>

        <section class="bb-match__block">
          <p class="bb-match__sec">조건추가</p>
          <div class="bb-match__heads">
            <span :class="headTone('left')">{{ leftHead }}</span>
            <span></span>
            <span :class="headTone('right')">{{ rightHead }}</span>
            <span></span>
          </div>
          <form class="bb-match__add-row" @submit.prevent="addRow">
            <select v-if="accountFirst" v-model="addTarget" class="bb-match__field" :class="[{ empty: !addTarget }, fieldTone('left')]">
              <option value="">{{ kind === 'rel' ? '상대계정을 선택하세요' : '계정을 선택하세요' }}</option>
              <option v-for="opt in targetOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
            <input
              v-else-if="kind === 'account'"
              v-model="addSource"
              class="bb-match__field"
              type="text"
              placeholder="예: 본인부담"
              maxlength="80"
            />
            <select v-else v-model="addSource" class="bb-match__field" :class="[{ empty: !addSource }, fieldTone('left')]">
              <option value="">계정을 선택하세요</option>
              <option v-for="code in sourceOptions" :key="code.scode" :value="code.scode">{{ code.sname }}</option>
            </select>
            <span class="bb-match__arrow" aria-hidden="true">→</span>
            <input
              v-if="accountFirst && kind === 'account'"
              v-model="addSource"
              class="bb-match__field"
              type="text"
              placeholder="예: 본인부담"
              maxlength="80"
            />
            <select v-else-if="accountFirst" v-model="addSource" class="bb-match__field" :class="[{ empty: !addSource }, fieldTone('right')]">
              <option value="">계정을 선택하세요</option>
              <option v-for="code in sourceOptions" :key="code.scode" :value="code.scode">{{ code.sname }}</option>
            </select>
            <select v-else v-model="addTarget" class="bb-match__field" :class="{ empty: !addTarget }">
              <option value="">자금원천을 선택하세요</option>
              <option v-for="opt in targetOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
            </select>
            <button type="submit" class="bb-match__add-btn" :disabled="!canAdd || saving">조건추가</button>
          </form>
        </section>

        <section v-if="loading || visibleRows.length" class="bb-match__block">
          <p class="bb-match__sec">목록</p>
          <div class="bb-match__heads">
            <span :class="headTone('left')">{{ leftHead }}</span>
            <span></span>
            <span :class="headTone('right')">{{ rightHead }}</span>
            <span></span>
          </div>
          <p v-if="loading" class="bb-match__empty">불러오는 중…</p>
          <div v-else class="bb-match__list">
            <template v-for="row in visibleRows" :key="row.id">
              <form v-if="editingId === row.id" class="bb-match__add-row" @submit.prevent="saveEdit(row)">
                <select v-if="accountFirst" v-model="editTarget" class="bb-match__field" :class="[{ empty: !editTarget }, fieldTone('left')]">
                  <option value="">{{ kind === 'rel' ? '상대계정을 선택하세요' : '계정을 선택하세요' }}</option>
                  <option v-for="opt in targetOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                </select>
                <select v-else v-model="editSource" class="bb-match__field" :class="[{ empty: !editSource }, fieldTone('left')]">
                  <option value="">계정을 선택하세요</option>
                  <option v-for="code in sourceOptions" :key="code.scode" :value="code.scode">{{ code.sname }}</option>
                </select>
                <span class="bb-match__arrow" aria-hidden="true">→</span>
                <input
                  v-if="kind === 'account'"
                  v-model="editSource"
                  class="bb-match__field"
                  type="text"
                  placeholder="예: 본인부담"
                  maxlength="80"
                />
                <select v-else-if="kind === 'rel'" v-model="editSource" class="bb-match__field" :class="[{ empty: !editSource }, fieldTone('right')]">
                  <option value="">계정을 선택하세요</option>
                  <option v-for="code in sourceOptions" :key="code.scode" :value="code.scode">{{ code.sname }}</option>
                </select>
                <select v-else v-model="editTarget" class="bb-match__field" :class="{ empty: !editTarget }">
                  <option value="">자금원천을 선택하세요</option>
                  <option v-for="opt in targetOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                </select>
                <button type="submit" class="bb-match__add-btn" :disabled="!canEdit">수정</button>
              </form>
              <div v-else class="bb-match__pair">
                <span class="bb-match__from" :class="accountTone(row, 'from')">{{ accountFirst ? row.targetLabel : row.sourceLabel }}</span>
                <span class="bb-match__arrow" aria-hidden="true">→</span>
                <span class="bb-match__to" :class="accountTone(row, 'to')">{{ accountFirst ? row.sourceLabel : row.targetLabel }}</span>
                <span class="bb-match__acts">
                  <button type="button" class="bb-match__del" title="고치기" @click="startEdit(row)">
                    <v-icon size="16">mdi-pencil-outline</v-icon>
                  </button>
                  <button type="button" class="bb-match__del" title="지우기" @click="removeRow(row.id)">
                    <v-icon size="16">mdi-close</v-icon>
                  </button>
                </span>
              </div>
            </template>
          </div>
        </section>
        <transition name="bb-unfold">
          <div v-if="importOpen" class="bb-match__fold">
            <div class="bb-match__piece">
              <p class="bb-match__sec">가져오기</p>
              <div class="bb-match__picker">
                <button type="button" class="bb-match__picker-btn" :class="{ empty: !sourceCode }" @click="orgOpen = !orgOpen">
                  <span class="bb-match__picker-name">{{ sourceCode ? selectedOrgName : '기관 고르기' }}</span>
                  <v-icon size="18">{{ orgOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </button>
                <transition name="bb-unfold">
                  <div v-if="orgOpen" class="bb-match__fold bb-match__fold--over">
                    <div class="bb-match__drop">
                      <div class="bb-match__orgs">
                        <button
                          v-for="org in orgs"
                          :key="org.mCode || 'recommend'"
                          type="button"
                          class="bb-match__org"
                          :class="{ on: sourceCode === org.mCode }"
                          @click="pickOrg(org)"
                        >
                          <span>{{ org.name }}</span>
                        </button>
                      </div>
                      <input
                        v-model="orgQuery"
                        class="bb-match__field"
                        type="search"
                        placeholder="이름 검색"
                        @input="searchOrgs"
                      />
                    </div>
                  </div>
                </transition>
              </div>
              <div v-if="sourceCode" class="bb-match__ways">
                <template v-if="kind === 'account'">
                  <p class="bb-match__note">이미 있는 적요는 그대로 두고, 없는 적요만 가져옴.</p>
                  <button type="button" class="bb-match__btn primary" :disabled="saving" @click="runImport('add')">없는 적요 더하기</button>
                </template>
                <template v-else>
                  <p class="bb-match__sec">가져오는 방법</p>
                  <button type="button" class="bb-match__way" :disabled="saving" @click="runImport('add')">
                    <strong>없는 것만 가져오기</strong>
                    <span>{{ keepHint }}</span>
                  </button>
                  <button type="button" class="bb-match__way" :disabled="saving" @click="runImport('replace')">
                    <strong>전부 바꾸기</strong>
                    <span>{{ replaceHint }}</span>
                  </button>
                </template>
              </div>
            </div>
          </div>
        </transition>

        <p v-if="error && !applyOpen" class="bb-match__error">{{ error }}</p>
      </div>

      <div class="bb-match__foot">
        <button type="button" class="bb-match__btn ghost" :class="{ on: importOpen }" @click="openImport">가져오기</button>
        <div class="bb-match__foot-main">
          <button v-if="canKeep" type="button" class="bb-match__btn" :disabled="saving" @click="keepRows">저장</button>
          <button type="button" class="bb-match__btn primary" :disabled="closedLocked" @click="openApply">다음</button>
        </div>
      </div>
    </div>
  </v-dialog>

  <v-dialog v-model="applyOpen" max-width="440" persistent>
    <div class="bb-match">
      <div class="bb-match__head">
        <div>
          <h3>적용</h3>
        </div>
        <div class="bb-match__head-tools">
          <button type="button" class="bb-match__q" :class="{ on: applyGuideOpen }" title="설명" @click="applyGuideOpen = !applyGuideOpen">
            <v-icon size="18">mdi-help-circle-outline</v-icon>
          </button>
          <button type="button" class="bb-match__x" title="닫기" @click="applyOpen = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>
      </div>
      <div class="bb-match__body">
        <div v-if="applyGuideOpen" class="bb-match__guide">
          <section v-for="(block, index) in applyGuideBlocks" :key="index">
            <strong>{{ block.title }}</strong>
            <div v-if="block.sample" class="bb-match__sample">
              <div class="bb-match__sample-side">
                <span v-if="block.sample.fromLabel" class="bb-match__sample-name">{{ block.sample.fromLabel }}</span>
                <span class="bb-match__sample-val">{{ block.sample.from }}</span>
              </div>
              <em>→</em>
              <div class="bb-match__sample-side">
                <span v-if="block.sample.toLabel" class="bb-match__sample-name">{{ block.sample.toLabel }}</span>
                <span class="bb-match__sample-val">{{ block.sample.to }}</span>
              </div>
            </div>
            <p v-for="(line, lineIndex) in block.lines" :key="lineIndex"><span>*</span>{{ line }}</p>
          </section>
        </div>
        <p v-if="kind === 'rel'" class="bb-match__hint">지출 계정이 있는 내역만 상대계정을 넣을 수 있음.</p>
        <p v-if="scopedCount" class="bb-match__hint">선택한 {{ scopedCount }}건만 적용함.</p>
        <div class="bb-match__ways">
          <button type="button" class="bb-match__way" :class="{ on: fillMode === 'empty' }" @click="pickFill('empty')">
            <strong>빈 곳만 채우기</strong>
          </button>
          <button type="button" class="bb-match__way" :class="{ on: fillMode === 'replace' }" @click="pickFill('replace')">
            <strong>{{ scopedCount ? '고른 항목만 바꾸기' : '이번 달 전부 바꾸기' }}</strong>
          </button>
        </div>
        <p v-if="previewLoading" class="bb-match__empty">확인하는 중…</p>
        <p v-else-if="fillMode && !previewRows.length" class="bb-match__empty">적용할 내역이 없음.</p>
        <div v-else-if="previewRows.length" class="bb-match__list">
          <div v-for="row in previewRows" :key="row.cbIdx" class="bb-match__preview">
            <div class="bb-match__preview-meta">
              <strong>{{ row.date }}</strong>
              <span>{{ row.memo || '-' }}</span>
              <em>{{ formatPrice(row.price) }}</em>
            </div>
            <p class="bb-match__answer">{{ row.before }} → {{ row.after }}</p>
          </div>
        </div>
        <p v-if="error" class="bb-match__error">{{ error }}</p>
      </div>
      <div class="bb-match__foot">
        <div class="bb-match__foot-main">
          <button type="button" class="bb-match__btn primary" :disabled="!canApply" @click="applyPreview">
            적용하기
          </button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { bankbookApi } from '@/services/api';

type Kind = 'account' | 'rel' | 'funding';
type Gubun = 'IN' | 'OUT';

interface CodeOpt { scode: string; sname: string; gubun?: string }
interface MatchRow {
  id: number;
  gubun: Gubun;
  source: string;
  target: string;
  sourceLabel: string;
  targetLabel: string;
}
interface PreviewRow {
  cbIdx: number;
  date: string;
  memo: string;
  price: number;
  before: string;
  after: string;
  patch: Record<string, string>;
}
interface OrgOpt { mCode: string; name: string }

const FUNDING = [
  { value: '04', label: '자부담' },
  { value: '05', label: '후원금' },
  { value: '06', label: '수익사업' },
  { value: '07', label: '보조금' },
];

const props = withDefaults(defineProps<{
  modelValue: boolean;
  kind: Kind;
  memberCode?: string | number;
  year?: string | number;
  month?: string | number;
  bizGubun?: string;
  bankCode?: string;
  closedLocked?: boolean;
  incomeCodes?: CodeOpt[];
  expenseCodes?: CodeOpt[];
  cbIdxs?: number[];
}>(), {
  memberCode: '',
  year: '',
  month: '',
  bizGubun: '',
  bankCode: '',
  closedLocked: false,
  incomeCodes: () => [],
  expenseCodes: () => [],
  cbIdxs: () => [],
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
  (e: 'applied'): void;
}>();

const gubun = ref<Gubun>('IN');
const rows = ref<MatchRow[]>([]);
const owned = ref(true);
const loading = ref(false);
const saving = ref(false);
const error = ref('');
const importOpen = ref(false);
const previewOpen = ref(false);
const addSource = ref('');
const addTarget = ref('');
const editingId = ref<number | null>(null);
const editSource = ref('');
const editTarget = ref('');
const orgQuery = ref('');
const orgs = ref<OrgOpt[]>([]);
const orgOpen = ref(false);
const selectedOrgName = ref('');
const sourceCode = ref('');
const previewRows = ref<PreviewRow[]>([]);
const previewLoading = ref(false);
const fillMode = ref<'' | 'empty' | 'replace'>('');
const applyOpen = ref(false);
const pickSideOnLoad = ref(false);

const keepHint = computed(() => (
  props.kind === 'funding'
    ? '이미 있는 계정은 그대로 두고, 없는 계정만 가져옴.'
    : '이미 있는 지출 계정은 그대로 두고, 없는 지출 계정만 가져옴.'
));
const replaceHint = computed(() => (
  props.kind === 'funding'
    ? '이 기관의 자금원천 목록을 지우고, 고른 기관 목록으로 바꿈.'
    : '이 기관의 상대계정 목록을 지우고, 고른 기관 목록으로 바꿈.'
));
const scopedCount = computed(() => (props.cbIdxs || []).filter((id) => Number(id) > 0).length);
const guideOpen = ref(false);
const applyGuideOpen = ref(false);
type GuideBlock = {
  title: string;
  lines: string[];
  sample?: { fromLabel?: string; from: string; toLabel?: string; to: string };
};
const guideBlocks = computed((): GuideBlock[] => {
  if (props.kind === 'rel') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '수입 계정', from: '식재료비수입', toLabel: '지출 계정', to: '생계비' },
        lines: [
          '지출 계정을 보고 상대계정(수입 계정)을 넣음.',
          '왼쪽은 상대계정, 오른쪽은 지출 계정임.',
          '예: 생계비의 상대계정은 식재료비수입.',
          '예: 급여(직접비)의 상대계정은 직원식재료수입.',
        ],
      },
      {
        title: '그대로 두는 내역',
        lines: [
          '수입 내역에는 상대계정을 넣지 않음.',
          '지출 계정이 비어 있으면 넣지 않음.',
          '목록에 없는 지출 계정은 그대로 둠. 예: 수용비 및 수수료',
        ],
      },
      {
        title: '등록',
        lines: ['지출 계정 하나에는 상대계정을 하나만 등록함.'],
      },
      {
        title: '추천',
        lines: [
          '이 기관에 저장한 목록이 없으면 공통 추천을 보여 줌.',
          '저장을 누르면 추천 목록이 이 기관 목록이 됨.',
          '추천을 고치거나 지우면, 저장을 누르지 않아도 추천 목록이 이 기관 목록이 됨.',
          '공통 추천 자체는 바뀌지 않음.',
        ],
      },
      {
        title: '가져오기',
        lines: ['없는 지출 계정만 가져오거나, 목록 전체를 바꿀 수 있음.'],
      },
    ];
  }
  if (props.kind === 'funding') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '계정', from: '생계비', toLabel: '자금원천', to: '자부담' },
        lines: [
          '계정을 보고 자금원천을 넣음.',
          '자금원천은 자부담, 후원금, 수익사업, 보조금임.',
          '왼쪽은 계정, 오른쪽은 자금원천임.',
          '예: 생계비는 자부담, 생계비(보조금)는 보조금.',
        ],
      },
      {
        title: '그대로 두는 내역',
        lines: [
          '계정이 비어 있으면 넣지 않음.',
          '목록에 없는 계정은 그대로 둠.',
          '수입에 등록한 계정은 지출 내역에 넣지 않음.',
          '지출에 등록한 계정은 수입 내역에 넣지 않음.',
        ],
      },
      {
        title: '등록',
        lines: ['계정 하나에는 자금원천을 하나만 등록함.'],
      },
      {
        title: '추천',
        lines: [
          '이 기관에 없는 계정만 추천으로 채움.',
          '이미 등록한 계정은 추천으로 바꾸지 않음.',
          '목록에서 지운 계정은 추천으로 다시 채우지 않음.',
        ],
      },
      {
        title: '가져오기',
        lines: ['없는 계정만 가져오거나, 목록 전체를 바꿀 수 있음.'],
      },
    ];
  }
  return [
    {
      title: '하는 일',
      sample: { fromLabel: '계정', from: '본인부담금수입', toLabel: '적요', to: '본인부담' },
      lines: [
        '적요를 보고 계정을 넣음.',
        '왼쪽은 넣을 계정, 오른쪽은 찾을 적요임.',
        '적요에 본인부담이 있으면 본인부담금수입으로 넣음.',
        '숫자와 날짜는 빼고 찾음. 9월 본인부담금도 본인부담금으로 찾음.',
        '본인부담과 본인부담금이 둘 다 맞으면 더 긴 본인부담금을 씀.',
      ],
    },
    {
      title: '그대로 두는 내역',
      lines: [
        '수입에 등록한 적요는 지출 내역에 넣지 않음.',
        '지출에 등록한 적요는 수입 내역에 넣지 않음.',
        '목록에 없는 적요는 그대로 둠. 예: 전기요금',
      ],
    },
    {
      title: '등록',
      lines: [
        '적요는 두 글자부터 등록함.',
        '같은 적요는 한 번만 등록함.',
      ],
    },
    {
      title: '추천',
      lines: [
        '이 기관에 저장한 목록이 없으면 공통 추천을 보여 줌.',
        '저장을 누르면 추천 목록이 이 기관 목록이 됨.',
        '추천을 고치거나 지우면, 저장을 누르지 않아도 추천 목록이 이 기관 목록이 됨.',
        '공통 추천 자체는 바뀌지 않음.',
      ],
    },
    {
      title: '가져오기',
      lines: [
        '다른 기관에서 없는 적요만 가져옴.',
        '이미 있는 적요는 그대로 둠.',
      ],
    },
  ];
});
const applyGuideBlocks = computed((): GuideBlock[] => {
  const tail = [
    '빈 곳만 채우기나 바꾸기를 고른 뒤, 적용하기를 눌러야 통장에 반영됨.',
    scopedCount.value
      ? `체크한 ${scopedCount.value}건만 적용함.`
      : '체크한 내역이 없으면 이번 달 내역을 적용함.',
    '통장을 하나 고르면 그 통장만 적용함.',
    '전체를 고르면 모든 통장에 적용함.',
    '적요 검색과 코드·이름 검색은 화면만 줄이고, 적용 대상은 줄지 않음.',
    '마감한 내역은 바꾸지 않음.',
    '넣을 값이 지금과 같으면 바꾸지 않음.',
    '바꿀 내역이 없으면 적용하기가 눌리지 않음.',
    '끝나면 바뀐 건수를 알려 줌.',
  ];
  const replaceTitle = scopedCount.value ? '고른 항목만 바꾸기' : '이번 달 전부 바꾸기';
  if (props.kind === 'rel') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '수입 계정', from: '식재료비수입', toLabel: '지출 계정', to: '생계비' },
        lines: [
          '목록에 있는 지출 계정이면 상대계정을 넣음.',
          '예: 생계비의 상대계정은 식재료비수입.',
          '수입 내역은 바꾸지 않음.',
          '지출 계정이 비어 있거나 목록에 없으면 그대로 둠.',
        ],
      },
      {
        title: '빈 곳만 채우기',
        lines: ['상대계정이 비어 있는 내역만 넣음.'],
      },
      {
        title: replaceTitle,
        lines: ['상대계정이 이미 있어도 목록의 상대계정으로 바꿈.'],
      },
      { title: '적용할 때', lines: tail },
    ];
  }
  if (props.kind === 'funding') {
    return [
      {
        title: '하는 일',
        sample: { fromLabel: '계정', from: '생계비', toLabel: '자금원천', to: '자부담' },
        lines: [
          '목록에 있는 계정이면 자금원천을 넣음.',
          '예: 생계비의 자금원천은 자부담.',
          '계정이 비어 있거나 목록에 없으면 그대로 둠.',
        ],
      },
      {
        title: '빈 곳만 채우기',
        lines: ['자금원천이 비어 있는 내역만 넣음.'],
      },
      {
        title: replaceTitle,
        lines: [
          '자금원천이 이미 있어도 목록의 자금원천으로 바꿈.',
          '예: 생계비(보조금)의 자금원천이 수익사업이어도 보조금으로 바꿈.',
        ],
      },
      { title: '적용할 때', lines: tail },
    ];
  }
  return [
    {
      title: '하는 일',
      sample: { fromLabel: '계정', from: '본인부담금수입', toLabel: '적요', to: '본인부담' },
      lines: [
        '적요가 목록과 맞으면 그 계정으로 넣음.',
        '목록에 없는 적요는 그대로 둠. 예: 전기요금',
      ],
    },
    {
      title: '빈 곳만 채우기',
      lines: ['계정이 비어 있는 내역만 넣음.'],
    },
    {
      title: replaceTitle,
      lines: ['계정이 이미 있어도 목록의 계정으로 바꿈.'],
    },
    { title: '적용할 때', lines: tail },
  ];
});
const title = computed(() => {
  if (props.kind === 'rel') return '상대계정';
  if (props.kind === 'funding') return '자금원천';
  return '계정';
});
const accountFirst = computed(() => props.kind === 'account' || props.kind === 'rel');
const sourceHead = computed(() => {
  if (props.kind === 'account') return '적요';
  if (props.kind === 'rel') return '지출 계정';
  return '계정';
});
const targetHead = computed(() => props.kind === 'rel' ? '수입 계정' : props.kind === 'funding' ? '자금원천' : '계정');
const leftHead = computed(() => accountFirst.value ? targetHead.value : sourceHead.value);
const rightHead = computed(() => accountFirst.value ? sourceHead.value : targetHead.value);
const headTone = (side: 'left' | 'right') => {
  if (props.kind === 'rel') return side === 'left' ? 'is-in' : 'is-out';
  if (side !== 'left') return '';
  return gubun.value === 'IN' ? 'is-in' : 'is-out';
};
const fieldTone = (side: 'left' | 'right') => headTone(side);
const accountTone = (row: MatchRow, side: 'from' | 'to') => {
  if (props.kind === 'rel') return side === 'from' ? 'is-in' : 'is-out';
  if (side !== 'from') return '';
  return row.gubun === 'IN' ? 'is-in' : 'is-out';
};
const visibleRows = computed(() => rows.value.filter((row) => row.gubun === gubun.value));
const sourceOptions = computed(() => (gubun.value === 'IN' ? props.incomeCodes : props.expenseCodes));
const targetOptions = computed(() => {
  if (props.kind === 'funding') return FUNDING;
  if (props.kind === 'rel') return props.incomeCodes.map((code) => ({ value: code.scode, label: code.sname }));
  const list = gubun.value === 'IN' ? props.incomeCodes : props.expenseCodes;
  return list.map((code) => ({ value: code.scode, label: code.sname }));
});
const canAdd = computed(() => addSource.value.trim().length >= (props.kind === 'account' ? 2 : 1) && !!addTarget.value && !saving.value);
const canEdit = computed(() => editSource.value.trim().length >= (props.kind === 'account' ? 2 : 1) && !!editTarget.value && !saving.value);
const canKeep = computed(() => !owned.value && rows.value.length > 0 && !loading.value);

const formatPrice = (value: number) => `${Number(value || 0).toLocaleString('ko-KR')}원`;

const loadRows = async () => {
  if (!props.memberCode) {
    rows.value = [];
    owned.value = true;
    return;
  }
  loading.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.listAutoMatches(props.memberCode, {
      kind: props.kind,
      year: props.year != null ? String(props.year) : undefined,
    });
    rows.value = res.data?.data || [];
    owned.value = res.data?.owned !== false;
    if (pickSideOnLoad.value && props.kind !== 'rel') {
      pickSideOnLoad.value = false;
      const hasIn = rows.value.some((row) => row.gubun === 'IN');
      const hasOut = rows.value.some((row) => row.gubun === 'OUT');
      if (!hasIn && hasOut) gubun.value = 'OUT';
    }
  } catch (err) {
    console.error(err);
    error.value = '목록을 불러오지 못했습니다.';
    rows.value = [];
    owned.value = true;
  } finally {
    loading.value = false;
  }
};

const addRow = async () => {
  if (!props.memberCode || !canAdd.value) return;
  saving.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.saveAutoMatch(props.memberCode, {
      kind: props.kind,
      gubun: props.kind === 'rel' ? 'OUT' : gubun.value,
      source: addSource.value.trim(),
      target: addTarget.value,
    });
    if (res.data?.success === false) {
      error.value = res.data?.message || '추가하지 못했습니다.';
      return;
    }
    addSource.value = '';
    addTarget.value = '';
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '추가하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const startEdit = (row: MatchRow) => {
  editingId.value = row.id;
  editSource.value = row.source;
  editTarget.value = row.target;
};

const saveEdit = async (row: MatchRow) => {
  if (!props.memberCode || !canEdit.value) return;
  const source = editSource.value.trim();
  const target = editTarget.value;
  if (source === row.source && target === row.target) {
    editingId.value = null;
    return;
  }
  saving.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.updateAutoMatch(props.memberCode, row.id, { source, target });
    if (res.data?.success === false) {
      error.value = res.data?.message || '수정하지 못했습니다.';
      return;
    }
    editingId.value = null;
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '수정하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const removeRow = async (id: number) => {
  if (!props.memberCode) return;
  error.value = '';
  try {
    await bankbookApi.deleteAutoMatch(props.memberCode, id);
    await loadRows();
  } catch (err) {
    console.error(err);
    error.value = '지우지 못했습니다.';
  }
};

const pickOrg = (org: OrgOpt) => {
  sourceCode.value = org.mCode;
  selectedOrgName.value = org.name;
  orgOpen.value = false;
};

const openImport = () => {
  orgOpen.value = false;
  if (importOpen.value) {
    importOpen.value = false;
    return;
  }
  previewOpen.value = false;
  importOpen.value = true;
  error.value = '';
  orgQuery.value = '';
  selectedOrgName.value = '';
  sourceCode.value = '';
  orgs.value = [];
  void loadOrgs();
};

const loadOrgs = async () => {
  if (!props.memberCode) return;
  try {
    const res = await bankbookApi.searchAutoMatchSources(props.memberCode, orgQuery.value.trim(), props.kind);
    const list = (res.data?.data || []) as OrgOpt[];
    orgs.value = list.filter((org) => org.mCode);
  } catch (err) {
    console.error(err);
    error.value = '기관을 찾지 못했습니다.';
  }
};

let searchTimer: ReturnType<typeof setTimeout> | null = null;
const searchOrgs = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => { void loadOrgs(); }, 250);
};

const keepRows = async () => {
  if (!props.memberCode || !canKeep.value) return;
  saving.value = true;
  error.value = '';
  try {
    await bankbookApi.keepAutoMatches(props.memberCode, { kind: props.kind });
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '저장하지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const runImport = async (mode: 'add' | 'replace') => {
  if (!props.memberCode || !sourceCode.value) return;
  saving.value = true;
  error.value = '';
  try {
    await bankbookApi.importAutoMatches(props.memberCode, {
      sourceCode: sourceCode.value,
      kinds: [props.kind],
      mode: props.kind === 'account' ? 'add' : mode,
    });
    importOpen.value = false;
    orgOpen.value = false;
    await loadRows();
  } catch (err: any) {
    error.value = err?.response?.data?.message || '가져오지 못했습니다.';
  } finally {
    saving.value = false;
  }
};

const openApply = () => {
  applyOpen.value = true;
  applyGuideOpen.value = false;
  fillMode.value = '';
  previewRows.value = [];
  previewLoading.value = false;
  error.value = '';
};

const pickFill = (mode: 'empty' | 'replace') => {
  fillMode.value = mode;
  void openPreview();
};

const openPreview = async () => {
  if (!props.memberCode || !fillMode.value) return;
  previewRows.value = [];
  previewLoading.value = true;
  error.value = '';
  try {
    const res = await bankbookApi.previewAutoMatches(props.memberCode, {
      year: String(props.year || ''),
      month: String(props.month || ''),
      bizGubun: props.bizGubun || undefined,
      bankCode: props.bankCode || undefined,
      kind: props.kind,
      mode: fillMode.value,
      cbIdxs: scopedCount.value ? props.cbIdxs : undefined,
    });
    previewRows.value = res.data?.data || [];
  } catch (err: any) {
    error.value = err?.response?.data?.message || '목록을 만들지 못했습니다.';
  } finally {
    previewLoading.value = false;
  }
};

const canApply = computed(() => (
  Boolean(fillMode.value)
  && previewRows.value.length > 0
  && !previewLoading.value
  && !saving.value
  && !props.closedLocked
));

const applyResultText = (ok: number, failed: number) => {
  const name = props.kind === 'rel' ? '상대계정' : props.kind === 'funding' ? '자금원천' : '계정';
  if (!ok && !failed) return '적용할 내역이 없음.';
  if (failed && ok) return `${name} ${ok}건은 적용했습니다. ${failed}건은 적용하지 못했습니다.`;
  if (failed) return `${name}을 적용하지 못했습니다.`;
  return `${name} ${ok}건을 적용했습니다.`;
};

const applyPreview = async () => {
  if (!canApply.value) return;
  if (error.value && !previewRows.value.length) {
    alert(error.value);
    return;
  }
  if (!previewRows.value.length) {
    alert(applyResultText(0, 0));
    return;
  }
  saving.value = true;
  error.value = '';
  try {
    const results = await Promise.allSettled(
      previewRows.value.map((row) => bankbookApi.update(row.cbIdx, row.patch))
    );
    const failed = results.filter((result) => result.status === 'rejected').length;
    const ok = results.length - failed;
    if (ok) emit('applied');
    alert(applyResultText(ok, failed));
    if (ok && !failed) applyOpen.value = false;
  } catch (err) {
    console.error(err);
    alert(applyResultText(0, previewRows.value.length));
  } finally {
    saving.value = false;
  }
};

const close = () => {
  importOpen.value = false;
  previewOpen.value = false;
  applyOpen.value = false;
  orgOpen.value = false;
  guideOpen.value = false;
  applyGuideOpen.value = false;
  error.value = '';
  emit('update:modelValue', false);
};

watch(() => props.modelValue, (open) => {
  if (!open) return;
  importOpen.value = false;
  previewOpen.value = false;
  applyOpen.value = false;
  orgOpen.value = false;
  guideOpen.value = false;
  applyGuideOpen.value = false;
  error.value = '';
  addSource.value = '';
  addTarget.value = '';
  editingId.value = null;
  fillMode.value = '';
  gubun.value = props.kind === 'rel' ? 'OUT' : 'IN';
  pickSideOnLoad.value = true;
  void loadRows();
});

watch(() => props.kind, () => {
  guideOpen.value = false;
  editingId.value = null;
  gubun.value = props.kind === 'rel' ? 'OUT' : 'IN';
  if (props.modelValue) void loadRows();
});

watch(gubun, () => {
  editingId.value = null;
});
</script>
